import { EmailThreadCard } from "./EmailThreadCard";
import { Column, Text } from "@/components";

import { email as emailUtils } from "@/lib/email";
import { Email } from "@/types";

export const EmailsList = ({
  candidateFirstName,
  candidateName,
  onClearReplyTarget,
  onReply,
  onToggleThread,
  openThreadIds,
  replyTarget,
  threads,
}: {
  candidateFirstName: string;
  candidateName: string;
  onClearReplyTarget: () => void;
  // Omitted on read-only surfaces, which drop the reply affordance entirely.
  onReply?: (email: Email) => void;
  onToggleThread: (threadId: string) => void;
  openThreadIds: string[];
  replyTarget: Email | null;
  threads: Email[][];
}) => {
  /* Render */
  const render = () => {
    if (threads.length === 0) {
      return (
        <Column className="items-center gap-1 pt-6 text-center">
          <Text variant="small">No emails</Text>
          <Text variant="muted" className="text-xs">
            Sent and received emails with {candidateFirstName} will show up
            here.
          </Text>
        </Column>
      );
    }

    return (
      <Column className="gap-2">
        {threads.map((thread) => {
          const threadId = emailUtils.threadKey(thread[0]);
          const isReplyActive =
            replyTarget !== null &&
            emailUtils.threadKey(replyTarget) === threadId;
          return (
            <EmailThreadCard
              key={threadId}
              activeReplyEmailId={isReplyActive ? replyTarget.id : undefined}
              candidateFirstName={candidateFirstName}
              candidateName={candidateName}
              isOpen={openThreadIds.includes(threadId)}
              isReplyActive={isReplyActive}
              onClearReply={onClearReplyTarget}
              onReply={onReply}
              onToggle={() => {
                onToggleThread(threadId);
              }}
              thread={thread}
            />
          );
        })}
      </Column>
    );
  };

  return (
    <Column className="min-h-0 flex-1 gap-2 overflow-y-auto px-2.5 py-2.5">
      {render()}
    </Column>
  );
};
